"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLeap = void 0;
function isLeap(year) {
    var condition1 = year % 400 === 0 && year % 100 === 0;
    var condition2 = year % 100 !== 0 && year % 4 === 0;
    if (condition1 || condition2) {
        return true;
    }
    return false;
}
exports.isLeap = isLeap;
